import { render } from "./AnswerChooser.vue?vue&type=template&id=bcdfc998"
import script from "./AnswerChooser.vue?vue&type=script&lang=js"
export * from "./AnswerChooser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__